// @ts-check
import PropTypes from 'prop-types';

import { timeAtCompany } from 'services/inputTokens';
import { getFilter } from 'selectors/organisation';
import { setFilterGroup } from 'actions/organisation';
import { contactsKeys } from 'components/Search/Filters/keys';
import { tagRender } from 'components/common/TagRender';
import { renderOption } from 'components/common/OptionRender';

import OrgFilterField from './OrgFilterField';
import OrgFilterSection from './OrgFilterSection';

// Mirrors the main-search Contacts section, plus the org-page-only
// Time at Company filter. Main search's "Moved organisation within last six
// months" is deliberately absent (SCIL-19355): it is the Time at Company
// '0 - 6 months' band, and the filter mapper translates it into that band.

const activeKeys = [
  contactsKeys.fullName.key,
  'lastName',
  'jobTitle',
  'timeAtCompany',
];

const OrgContactsSection = ({ organisationId, loading }) => (
  <OrgFilterSection
    organisationId={organisationId}
    icon='user'
    title='Contacts'
    activeKeys={activeKeys}
  >
    <OrgFilterField
      filterType='token'
      filterId={contactsKeys.fullName.key}
      organisationId={organisationId}
      setFilterGroup={setFilterGroup}
      getFilter={getFilter}
      placeholder='Full Name'
      disabled={loading}
      includeExclude
    />
    <OrgFilterField
      filterType='token'
      filterId='lastName'
      organisationId={organisationId}
      setFilterGroup={setFilterGroup}
      getFilter={getFilter}
      placeholder='Last Name'
      disabled={loading}
      includeExclude
    />
    <OrgFilterField
      filterType='token'
      filterId='jobTitle'
      organisationId={organisationId}
      setFilterGroup={setFilterGroup}
      getFilter={getFilter}
      placeholder='Job Title'
      disabled={loading}
      includeExclude
    />
    <OrgFilterField
      filterType='selectIncludeExclude'
      mode={'multiple'}
      style={{ width: '100%' }}
      renderOption={renderOption}
      tagRender={tagRender}
      options={timeAtCompany}
      filterId='timeAtCompany'
      organisationId={organisationId}
      setFilterGroup={setFilterGroup}
      getFilter={getFilter}
      placeholder='Time at Company'
      disabled={loading}
    />
  </OrgFilterSection>
);

OrgContactsSection.propTypes = {
  organisationId: PropTypes.number.isRequired,
  loading: PropTypes.bool,
};

export default OrgContactsSection;
